import { lazy } from "react";
import { Navigate } from "react-router-dom";

import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";

const VendorList = lazy(() => import("../components/vendorList"));
const Vendor = lazy(() => import("../components/vendorCreate"));
const VendorEditView = lazy(() => import("../components/vendorEditView"));

// import { getLocalStorageData } from "../../../../shared/utils/localStorage";

const administratorRoute = {
  icon: EmojiTransportationIcon,
  name: "Vendor Management",
  link: "/vendor-management",
  path: "vendor-management",
  index: 3,
  element: "",
  children: [
    {
      path: "vendors",
      element: <VendorList />,
      name: "Vendors",
      permission: "Vendors-Read",
      link: "/vendor-management/vendors",
      //   permission: "Vendor List-Read",
      icon: EmojiTransportationIcon,
      index: 0,
    },
    {
      path: "vendors/create",
      element: <Vendor />,
    },
    {
      path: "vendors/:id",
      element: <VendorEditView />,
    },
    {
      path: "",
      element: <Navigate to="vendors" replace />,
    },
  ],
};
export default administratorRoute;
